<script>
  import { DropdownDivider, Sidebar, SidebarGroup } from 'flowbite-svelte';
  import { Link } from 'svelte-routing';
  import { useLocation } from 'svelte-routing';
  import LanguageSelector from './LanguageSelector.svelte';
  import SideNavFeedback from './SideNavFeedback.svelte';
  import SideNavSidebarItem from './SideNavSidebarItem.svelte';

  const location = useLocation();

  export let pages;
  export let showLanguageSelector = false;

  $: activeUrl = $location.pathname;
</script>

<Sidebar
  asideClass="overflow-y-auto hidden border-r border-gray-200 bg-white p-4 md:flex flex-col justify-between"
  {activeUrl}
>
  <SidebarGroup>
    {#each pages as { divider, meta, path, icon, onClick, badge }}
      {#if divider}
        <DropdownDivider class="!my-4" />
      {/if}
      {#if !divider}
        {#if path}
          <Link class="w-full" to={path} on:click={onClick}>
            <SideNavSidebarItem
              href={path}
              label={meta.title}
              active={activeUrl === path}
              {badge}
              {icon}
            />
          </Link>
        {:else}
          <button class="w-full" on:click={onClick}>
            <SideNavSidebarItem
              label={meta.title}
              active={activeUrl === path}
              {badge}
              {icon}
            />
          </button>
        {/if}
      {/if}
    {/each}
    {#if showLanguageSelector}
      <DropdownDivider class="!my-4" />
      <LanguageSelector />
    {/if}
  </SidebarGroup>
  <SideNavFeedback />
</Sidebar>
